import { useEffect, useState } from 'react';
import NavLink from '@material-tailwind/react/NavLink';
import { BlockchainService } from '../services/blockchainService';
import type { HygraphSocialLink } from '../types';

// Fallback icons for backward compatibility
import Discord from '../assets/elements/SVG ASSETS/discord.svg';
import Github from '../assets/elements/SVG ASSETS/github.svg';
import Twitter from '../assets/elements/SVG ASSETS/twitter.svg';
import Telegram from '../assets/elements/SVG ASSETS/telegram.svg';

const fallbackIcons: { [key: string]: string } = {
  discord: Discord,
  github: Github,
  twitter: Twitter,
  telegram: Telegram,
};

const platformLabels: { [key: string]: string } = {
  discord: 'Discord',
  github: 'GitHub',
  telegram: 'Telegram',
  twitter: 'X',
  x: 'X',
};

const platformLabel = (platform: string) => platformLabels[platform.toLowerCase()] ?? platform;

export default function Social() {
  const [socialLinks, setSocialLinks] = useState<HygraphSocialLink[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSocialLinks();
  }, []);

  async function loadSocialLinks() {
    try {
      setLoading(true);
      const data = await BlockchainService.getSocialLinks();
      setSocialLinks(data);
    } catch (err) {
      console.error('Failed to load social links from Hygraph:', err);
      // Use fallback data if Hygraph fails
      setSocialLinks([
        { id: '1', platform: 'github', url: 'https://github.com/kingnodes', icon: undefined, isActive: true, sortOrder: 1, createdAt: '', updatedAt: '' },
        { id: '2', platform: 'discord', url: 'https://discord.com/invite/TBuaH3GYpN', icon: undefined, isActive: true, sortOrder: 2, createdAt: '', updatedAt: '' },
        { id: '3', platform: 'twitter', url: 'https://twitter.com/kingnodes', icon: undefined, isActive: true, sortOrder: 3, createdAt: '', updatedAt: '' },
        { id: '4', platform: 'telegram', url: 'https://t.me/kingnodes', icon: undefined, isActive: true, sortOrder: 4, createdAt: '', updatedAt: '' },
      ]);
    } finally {
      setLoading(false);
    }
  }

  function getIconSrc(socialLink: HygraphSocialLink): string {
    // Use Hygraph icon if available, otherwise fallback to local asset
    return socialLink.icon?.url || fallbackIcons[socialLink.platform.toLowerCase()] || '';
  }

  if (loading) {
    return <div className="nav-icons">Loading...</div>;
  }

  return (
    <>
      {socialLinks.map(link => (
        <NavLink
          key={link.id}
          target="_blank"
          rel="noopener noreferrer"
          className={link.platform === 'github' ? "px-0 nav-icons" : undefined}
          href={link.url}
          ripple="light"
        >
          <img
            className='nav-icons'
            src={getIconSrc(link)}
            alt={`Kingnodes on ${platformLabel(link.platform)}`}
          />
        </NavLink>
      ))}
    </>
  );
}
